/**
 * FMINQTY (мінімальна кількість замовлення) відповідає одночасно і за мінімум,
 * і за кратність: замовлення повинно бути кратним цьому числу (а отже, і не
 * меншим за нього). FMULTQTY наразі не використовується.
 *
 * @param {Object} row - рядок товару з полем FMINQTY
 * @returns {number} - діюча кількість для розрахунків (мінімум 1)
 */
export default function getEffectiveOrderQty(row) {
    return Number(row?.FMINQTY) || 1;
}
